import styled from 'styled-components'
import { t } from 'i18next'
import sentBn from '@/assets/image/gold/sent_bn.png'

/**
 * 회원가입 창의 「ユーザー登録契約」 약관 창 — gold8.bet PC .agreementDialog 실측:
 *   폭 698, 흰 바탕·모서리 5, 회색(#808080) 머리말 21px, 본문 20px 여백·최대 500px 안에서 스크롤,
 *   점 목록(줄 높이 28px) + 빨간 안내 한 줄, 아래 오른쪽 「了解しました」 버튼(sent_bn.png 위/아래 = 보통/올렸을 때).
 *   문구는 언어 파일에 하드코딩(관리 화면 없음, 사용자 지시 2026-10-19):
 *     goldRegister.terms(배열) · goldRegister.termsNote — 중국어는 gold 원문, 나머지 언어는 번역.
 *     gold 는 일본어·영어 화면에서도 본문을 중국어로 보여 주고 제목·버튼만 바꾼다.
 */

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.8);
  overflow-y: auto;
`

const Dialog = styled.div`
  position: absolute;
  top: 94px;
  left: 50%;
  transform: translateX(-50%);
  width: 698px;
  max-width: calc(100% - 20px);
  border-radius: 5px;
  background: #fff;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  font-size: 14px;
  color: #000;
`

const Header = styled.div`
  padding: 15px;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0 0;
  background: #808080;
  font-size: 21px;
  color: #fff;
`

const Body = styled.div`
  max-height: min(500px, calc(100vh - 260px));
  padding: 20px;
  overflow: auto;
  /* 사이트 전역 keep-all 이면 중국어가 문장부호에서만 줄바꿈돼 gold 보다 줄이 늘어난다 */
  word-break: normal;
  ul { margin: 0; padding: 0 20px; list-style: disc outside; }
  li { line-height: 28px; }
  p { margin: 20px 0 0; color: #f00; }
`

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 15px;
  border-top: 1px solid #e5e5e5;
`

const OkBtn = styled.button`
  width: 119px;
  height: 45px;
  padding: 0;
  border: 0;
  border-radius: 3px;
  background: url(${sentBn}) 0 0 no-repeat;
  font-size: 15px;
  font-weight: 700;
  color: #454545;
  cursor: pointer;
  &:hover { background-position: 0 -46px; }
`

export default function GoldTermsModal({ onClose }) {
  const terms = t('goldRegister.terms', { returnObjects: true })
  const lines = Array.isArray(terms) ? terms : []
  return (
    <Overlay onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <Dialog role="dialog" aria-modal="true" aria-labelledby="gold-terms-title">
        <Header id="gold-terms-title">{t('goldRegister.agreeLink')}</Header>
        <Body>
          <ul>
            {lines.map((line) => <li key={line}>{line}</li>)}
          </ul>
          <p>{t('goldRegister.termsNote')}</p>
        </Body>
        <Footer>
          <OkBtn type="button" onClick={onClose}>{t('goldRegister.agreeOk')}</OkBtn>
        </Footer>
      </Dialog>
    </Overlay>
  )
}
